import { memo } from 'react';

function ZetaIcon() {
  return (
    <svg width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.10714" y="0.607143" width="44.7857" height="44.7857" rx="22.3929" fill="#161C24" />
      <rect x="1.10714" y="0.607143" width="44.7857" height="44.7857" rx="22.3929" stroke="#8E33FF" stroke-width="0.785714" />
      <path d="M11.7815 32.2852V26.7379L21.8406 18.3799V17.7882H12.1513V13.9421H26.9441V19.4894L16.885 27.8473V28.439H27.2399V32.2852H11.7815Z" fill="white" />
      <path
        d="M29.6505 28.7595C29.0792 28.468 29.0792 27.6576 29.6505 27.3661L30.5017 26.9289C31.2596 26.5383 31.8775 25.9203 32.2681 25.1625L32.7054 24.3113C32.9969 23.74 33.8072 23.74 34.0987 24.3113L34.5359 25.1625C34.9265 25.9203 35.5445 26.5383 36.3024 26.9289L37.1535 27.3661C37.7249 27.6576 37.7249 28.468 37.1535 28.7595L36.3024 29.1967C35.5445 29.5873 34.9265 30.2053 34.5359 30.9632L34.0987 31.8143C33.8072 32.3856 32.9969 32.3856 32.7054 31.8143L32.2681 30.9632C31.8775 30.2053 31.2596 29.5873 30.5017 29.1967L29.6505 28.7595Z"
        fill="#C684FF"
      />
    </svg>
  );
}

export default memo(ZetaIcon);
